export const isTouchSupported = () => (
  !!(typeof window !== 'undefined'
    && ('ontouchstart' in window
      || (window.DocumentTouch
        && typeof document !== 'undefined'
        && document instanceof window.DocumentTouch)))
  || !!(typeof navigator !== 'undefined'
    && (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
)

const userAgent = window.navigator.userAgent.toLowerCase()
const isSafari = /safari/.test(userAgent)
const isIos = /iphone|ipod|ipad/.test(userAgent)

const isIphoneXScreen = window.screen.width * (window.devicePixelRatio || 1) === 1125
  && window.screen.height * (window.devicePixelRatio || 1) === 2436

const isWebview = isIos && !isSafari

export const isIPhoneXApp = isWebview && isIphoneXScreen
